import { Box, Checkbox, Divider, Paper, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';

import Grid from '@mui/material/Grid2';
import React, {
  useEffect,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { Button } from '@mui/material';
import { useStore } from '../../utils/store';
import DeleteForeverIcon from '@mui/icons-material/Delete';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';
import AlertMessageComponent from '../../components/AlertMessageComponent';

import AddButtonComponent from '../../components/form/AddButtonComponent';

import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import ShiftSaveButtons from './parts/SaveButtons';
import TextFieldAreaComponent from '../../components/form/TextFieldAreaComponent';
import tabStore from './tabStore';
import ButtonComponent from '../../components/form/ButtonComponent';
import { getLoginName } from '../../utils/storageUtil';
interface TasksProps {
  currentRecord: any;
  tasksList: any[];
  goBack: () => void;
  goRefresh: () => void;
  loadTasks: () => void;
  updateShiftStatus: (record: any) => void;
}
export type TaskRef = {
  handleSave: (type: any) => void;
};
const Tasks = forwardRef<TaskRef, TasksProps>(
  (
    {
      currentRecord,
      tasksList,
      goBack,
      goRefresh,
      loadTasks,
      updateShiftStatus,
    },
    ref
  ) => {
    const isInitialLoad = useRef(true);
    useImperativeHandle(ref, () => ({
      handleSave,
    }));
    const [inProgress, setInProgress] = useState(false);
    const [currentTask, setCurrentTask] = useState({ id: 0, description: '' });
    const [TaskDialogOpen, setTaskDialogOpen] = useState<boolean>(false);
    const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);

    const [processing, setProcessing] = useState<boolean>(false);
    const [publishing, setPublishing] = useState<boolean>(false);

    const { getAdmin } = useStore();

    const [httpError, setHttpError] = useState({
      message: '',
      open: false,
    });
    const [checked, setChecked] = React.useState<number[]>([-1]);

    const handleToggle = (value: number) => () => {
      tabStore.updateField('tab1Field', 'updated');
      if (checked.length > 0) {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
      }
    };

    const handleSaveTasks = async () => {
      const shiftReq: any = {
        description: currentTask.description,
        isCompleted: false,
      };
      const endpoint =
        Constants.apiURL +
        Constants.shiftURL +
        `/${currentRecord.shiftId}/task`;

      let response: any;

      try {
        if (currentRecord) {
          response = await HttpServices.post(endpoint, shiftReq, {
            headers: { Authorization: `Bearer ${getAdmin()}` },
          });
        }
        setTaskDialogOpen(false);
        setCurrentTask({ id: 0, description: '' });
        loadTasks();
      } catch (error: any) {
        console.error(`PATCH Error:`, error);
        setHttpError({
          message: error.message,
          open: true,
        });
      } finally {
        setProcessing(false);
        setPublishing(false);
      }
    };
    const handleSave = async (type: number) => {
      if (type === 0) {
        setProcessing(true);
      } else {
        setPublishing(true);
      }
      const selectedTasks = tasksList.filter((task: any) =>
        checked.includes(task.id)
      );

      try {
        tabStore.updateField('tab1Field', '');
        if (selectedTasks.length > 0) {
          for (var i = 0; i < selectedTasks.length; i++) {
            await handleCompletedTask({
              id: selectedTasks[i].id,
              description: selectedTasks[i].description,
              isCompleted: true,
            });
          }
        }
        if (type === 1) {
          goBack();
        }
        setHttpError({
          message: 'Tasks Updated',
          open: true,
        });
        loadTasks();
        if (type === 3 || type === 4 || type === 1) {
          updateShiftStatus({
            shiftId: currentRecord.shiftId,
            newShiftStatusId: type,
          });
          if (type === 4 || type === 1) {
            goBack();
          }
          return true;
        } else {
          goRefresh();
          return true;
        }
      } catch (error: any) {
        console.error(`PATCH Error:`, error);
        setHttpError({
          message: error.message,
          open: true,
        });
      } finally {
        setProcessing(false);
        setPublishing(false);
      }
    };
    const handleCompletedTask = async (taskData: any) => {
      const endpoint =
        Constants.apiURL + Constants.shiftURL + `/task/${taskData.id}`;

      return await HttpServices.put(endpoint, taskData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
    };

    const TaskDialogContent = () => {
      return (
        <Box className="row mb-3 mt-2" sx={{ textAlign: 'right' }}>
          <Typography component={'h1'} sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
            Task
          </Typography>
          <Box sx={{ width: '800px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
                mt: 2,
              }}
            >
              <TextFieldAreaComponent
                name={'notebox'}
                value={currentTask.description}
                isRequired={false}
                errorStr={''}
                minRows={7}
                keyName={'notebox'}
                label=""
                onChange={(e: any) => {
                  setCurrentTask({
                    id: currentTask.id,
                    description: e.target.value,
                  });
                }}
              />
            </Box>
          </Box>
          <Button
            color="primary"
            sx={{ color: '#fff !important', mt: 3, mb: 3, textAlign: 'right' }}
            variant="contained"
            onClick={() => {
              handleSaveTasks();
              setTaskDialogOpen(false);
            }}
          >
            Save
          </Button>
        </Box>
      );
    };
    const handleDelete = async () => {
      const shiftReq: any = {
        status: '0',
      };
      const endpoint =
        Constants.apiURL +
        Constants.shiftURL +
        `/task/${currentTask.id}/remove`;
      setInProgress(true);
      try {
        if (currentRecord) {
          await HttpServices.patch(endpoint, shiftReq, {
            headers: { Authorization: `Bearer ${getAdmin()}` },
          });
        }
        setCurrentTask({ id: 0, description: '' });
        loadTasks();
        setInProgress(false);
        setConfirmDailogOpen(false);
        setHttpError({
          message: 'Task deleted successfully.',
          open: true,
        });
      } catch (error: any) {
        setInProgress(true);
        console.error(`PATCH Error:`, error);
        setHttpError({
          message: error.message,
          open: true,
        });
      } finally {
        setInProgress(true);
        setProcessing(false);
        setPublishing(false);
      }
    };
    const dialogConfirmation = () => {
      return (
        <Box sx={{ width: '450px' }}>
          <h2>Are you sure you want to delete this task?</h2>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <ButtonComponent
              errors={[]}
              keyName="okbuttonconfirm"
              label={inProgress ? 'processing...' : 'Yes'}
              onClick={handleDelete}
            />
            <ButtonComponent
              errors={[]}
              keyName="cancelbuttonconfirm"
              label="Cancel"
              onClick={() => {
                setConfirmDailogOpen(false);
                setCurrentTask({ id: 0, description: '' });
              }}
            />
          </Box>
        </Box>
      );
    };
    return (
      <Paper sx={{ width: '100%' }} elevation={0} className="mt-4">
        <Box
          sx={{
            padding: '24px 16px 16px 16px',
            mb: 2,
            display: 'grid',
            gap: '32px',
          }}
        >
          <Grid size={12} sx={{ gap: 20, marginTop: '35px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                mb: 2,
              }}
            >
              <Typography variant="h6">Tasks</Typography>
              {(currentRecord.shiftStatusId === 0 ||
                currentRecord.shiftStatusId === 2) && (
                <AddButtonComponent
                  onClick={() => {
                    setTaskDialogOpen(true);
                  }}
                  keyName="quoteaddicon"
                  label="Add New"
                />
              )}
            </Box>
            {tasksList.length > 0 && (
              <List sx={{ width: '100%' }}>
                {tasksList.map((item: any, index: any) => {
                  return (
                    <ListItem
                      key={index + '_' + item.description}
                      secondaryAction={
                        item.isCompleted === false && (
                          <IconButton
                            edge="end"
                            aria-label="delete task"
                            onClick={() => {
                              setCurrentTask(item);
                              setConfirmDailogOpen(true);
                            }}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                        )
                      }
                      disablePadding
                    >
                      <ListItemButton
                        role={undefined}
                        disabled={item.isCompleted}
                        onClick={handleToggle(item.id)}
                        dense
                      >
                        <ListItemIcon>
                          <Checkbox
                            disabled={item.isCompleted}
                            edge="start"
                            checked={
                              checked.includes(item.id) || item.isCompleted
                            }
                            tabIndex={-1}
                            disableRipple
                          />
                        </ListItemIcon>
                        <ListItemText
                          id={'itemsTxt_' + index}
                          primary={item.description}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            )}
          </Grid>
          <Divider />
          <ShiftSaveButtons
            processing={processing}
            publishing={publishing}
            handleSave={handleSave}
            shiftStatus={currentRecord ? currentRecord.shiftStatusId : 0}
          />

          <SimpleDialogComponent
            title={''}
            dialogContent={TaskDialogContent()}
            open={TaskDialogOpen}
            handleClose={() => {
              setTaskDialogOpen(false);
            }}
          />
          <AlertMessageComponent
            type={'success'}
            open={httpError.open}
            handleClose={() => {
              setHttpError({ open: false, message: '' });
            }}
            message={httpError.message}
          />
          <SimpleDialogComponent
            title={'You have unsaved changes'}
            dialogContent={dialogConfirmation()}
            open={confirmDailogOpen}
            handleClose={() => {
              setConfirmDailogOpen(false);
            }}
          />
        </Box>
      </Paper>
    );
  }
);

export default Tasks;
